import { render, staticRenderFns } from "./AdminProjectManagement.vue?vue&type=template&id=206ce01a"
import script from "./AdminProjectManagement.vue?vue&type=script&lang=js"
export * from "./AdminProjectManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminProjectManagement.vue?vue&type=style&index=0&id=206ce01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports